
export enum SearchCallerTypeEnum {
    unspecified = 'UNSPECIFIED',
    topics = 'TOPICS',
    briefings = 'BRIEFINGS'
};
